//@flow
import type { TableColumnTypes } from 'common/entity/generic/EntityImportContainer/types';
import { TeamImportHelper } from 'common/entity/teamMaster/TeamImportHelper';

const TEAM_IMPORT_FORMAT: Array<TableColumnTypes> = [
    {
        titleKey: 'masterTeamProperties.id',
        id: 'id',
        disabled: true,
        fixed: true,
        required: true,
        templateValue: 'masterImportTemplateValues.masterTeam.id'
    },
    {
        titleKey: 'masterTeamProperties.code',
        id: 'code',
        disabled: true,
        templateValue: 'masterImportTemplateValues.masterTeam.code'
    },
    {
        titleKey: 'masterTeamProperties.name',
        id: 'name',
        required: true,
        templateValue: 'masterImportTemplateValues.masterTeam.name'
    },
    {
        titleKey: 'masterTeamProperties.businessUnitId',
        id: 'businessUnitId',
        accessor: ['businessUnitId'],
        templateValue: 'masterImportTemplateValues.masterTeam.businessUnitId',
        processCell: TeamImportHelper.processBusinessUnitId,
        serializeCell: TeamImportHelper.serializeBusinessUnitId,
        validateCell: TeamImportHelper.validateBusinessUnitId
    },
    {
        titleKey: 'masterTeamProperties.cityId',
        id: 'cityId',
        accessor: ['cityId'],
        templateValue: 'masterImportTemplateValues.masterTeam.cityId',
        processCell: TeamImportHelper.processCityId,
        serializeCell: TeamImportHelper.serializeCityId,
        validateCell: TeamImportHelper.validateCityId
    }
];

export default TEAM_IMPORT_FORMAT;
